import { AddIntegrationChannelDrawer } from '@modules/integrationsV2/components/AddIntegrationChannelDrawer';
import { useFetchConnectedIntegrations } from '@modules/integrationsV2/hooks';
import { IntegrationsActionType } from '@modules/integrationsV2/store/integrationsActionType';
import { useIntegrationsStore } from '@modules/integrationsV2/store/integrationsStore';
import { getCanAddIntegrationChannelsMetadata } from '@modules/integrationsV2/utils';
import { useEffect, useState } from 'react';

export const SelectedAddIntergationChannelDrawer = () => {
  const dispatch = useIntegrationsStore(({ dispatch }) => dispatch);
  const selectedIntegrationIDToUpdate = useIntegrationsStore(
    ({ view }) => view.selectedIntegrationIDToUpdate,
  );

  const [isAddChannelDrawerOpen, setIsAddChannelDrawerOpen] = useState(false);

  const { connectedIntegrations } = useFetchConnectedIntegrations({
    fetchPolicy: 'cache-first', // We already have the data in the cache, so we don't need to refetch it
  });

  const integrationToUpdate = selectedIntegrationIDToUpdate
    ? connectedIntegrations.find(
        ({ id }) => id === selectedIntegrationIDToUpdate,
      )
    : null;

  const canAddChannel = integrationToUpdate
    ? getCanAddIntegrationChannelsMetadata(integrationToUpdate.channel.type)
    : false;

  const shouldOpenAddChannelDrawer = !!integrationToUpdate && canAddChannel;

  useEffect(() => {
    if (shouldOpenAddChannelDrawer) {
      setIsAddChannelDrawerOpen(true);
    }
  }, [shouldOpenAddChannelDrawer]);

  if (!integrationToUpdate) {
    return null;
  }

  const onDrawerClose = () => {
    setIsAddChannelDrawerOpen(false);
    dispatch({
      type: IntegrationsActionType.SET_VIEW,
      payload: {
        selectedIntegrationIDToUpdate: null,
      },
    });
  };

  return (
    <AddIntegrationChannelDrawer
      isOpen={isAddChannelDrawerOpen}
      onDrawerClose={onDrawerClose}
      integrationID={integrationToUpdate.id}
      integrationData={integrationToUpdate.data}
      integrationType={integrationToUpdate.integrationType}
      integrationChannel={integrationToUpdate.channel}
      channelDescriptions={
        integrationToUpdate.description?.descriptionMap ?? []
      }
    />
  );
};
